import React from 'react';
import { CustomButton, Modifiers } from '@fw-nextgen/fw-components';
import { FormattedMessage } from 'react-intl';

import routerStore from '@app/src/common/store/RouterStore';
import AuthWindow from '../components/AuthWindow';
import AuthWindowLogo from '../components/AuthWindowLogo';

const LogOutPage = () => {
  const onClick = () => routerStore.gotoAuthentication();

  return (
    <AuthWindow>
      <AuthWindowLogo />
      <div className="auth-window__form auth-window__form_center-vertically">
        <h5 className="logout__heading">
          <FormattedMessage id="log.out.heading" />
        </h5>
        <CustomButton
          modifiers={[Modifiers.SMALL]}
          className="auth-window__button"
          value="button.login"
          onClick={onClick}
        />
      </div>
    </AuthWindow>
  );
};

export default LogOutPage;
